var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "v-select" },
    [
      _c("VInput", {
        attrs: {
          type: "text",
          value: _vm.selectText,
          tmp: _vm.selected[_vm.label],
          placeholder: _vm.placeholder,
          label: _vm.label_inp,
          autocomplete: "auto-off",
          role: "combobox"
        },
        on: { input: _vm.handleInput, blur: _vm.handleBlur },
        nativeOn: {
          mousedown: function($event) {
            return _vm.toggleDropdown($event)
          }
        },
        scopedSlots: _vm._u([
          {
            key: "append-icon",
            fn: function() {
              return [
                _c("div", { staticClass: "vs__arrow-ico" }, [
                  _c(
                    "svg",
                    {
                      attrs: {
                        width: "14px",
                        height: "9px",
                        "enable-background": "new 0 0 14 9",
                        viewBox: "0 0 14 9",
                        xmlns: "http://www.w3.org/2000/svg"
                      }
                    },
                    [
                      _c("path", {
                        attrs: {
                          "clip-rule": "evenodd",
                          d: "m.3 1.4 1.4-1.4 5.3 5.3 5.3-5.3 1.4 1.4-6.7 6.7z",
                          fill: "#b2b2b2",
                          "fill-rule": "evenodd"
                        }
                      })
                    ]
                  )
                ])
              ]
            },
            proxy: true
          }
        ])
      }),
      _vm._v(" "),
      _c("transition", { attrs: { name: "vs__fade" } }, [
        _vm.dropdownOpen
          ? _c("div", [
              _c("div", { staticClass: "vs__dropdown-menu-border" }),
              _vm._v(" "),
              _c(
                "ul",
                {
                  ref: "dropdownMenu",
                  staticClass: "vs__dropdown-menu",
                  attrs: { id: "vs" + _vm.uid + "__listbox", role: "listbox" },
                  on: {
                    mousedown: function($event) {
                      $event.preventDefault()
                      return _vm.onMousedown($event)
                    },
                    mouseup: _vm.onMouseUp
                  }
                },
                [
                  _vm._l(_vm.filteredOptions, function(option, index) {
                    return _c(
                      "li",
                      {
                        key: _vm.getOptionKey(option),
                        staticClass: "vs__dropdown-option",
                        class: {
                          "vs__dropdown-option--selected": _vm.isOptionSelected(
                            option
                          ),
                          "vs__dropdown-option--highlight":
                            index === _vm.typeAheadPointer
                        },
                        attrs: {
                          id: "vs" + _vm.uid + "__option-" + index,
                          role: "option",
                          "aria-selected":
                            index === _vm.typeAheadPointer ? true : null
                        },
                        on: {
                          mouseover: function($event) {
                            _vm.selectable(option)
                              ? (_vm.typeAheadPointer = index)
                              : null
                          },
                          mousedown: function($event) {
                            $event.preventDefault()
                            $event.stopPropagation()
                            _vm.selectable(option) ? _vm.select(option) : null
                          }
                        }
                      },
                      [
                        _vm._t(
                          "option",
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.getOptionLabel(option)) +
                                "\n          "
                            )
                          ],
                          null,
                          option
                        )
                      ],
                      2
                    )
                  }),
                  _vm._v(" "),
                  _vm.filteredOptions.length === 0
                    ? _c(
                        "li",
                        { staticClass: "vs__no-options" },
                        [_vm._t("no-options")],
                        2
                      )
                    : _vm._e()
                ],
                2
              )
            ])
          : _c("ul", {
              staticStyle: { display: "none", visibility: "hidden" },
              attrs: { id: "vs" + _vm.uid + "__listbox", role: "listbox" }
            })
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }